import React from 'react';
import Image, { MediaItemWithMods } from 'frontastic/lib/image/nextImage';
import { Reference, ReferenceLink } from 'helpers/reference';
import useI18n from 'helpers/hooks/useI18n';

type CategoryCard = {
  image: MediaItemWithMods;
  text?: string;
  enableLink?: boolean;
  linkReference?: Reference;
};

interface Props {
  cards: Array<CategoryCard>;
}

const CategoryCards: React.FC<Props> = ({ cards }) => {
  const { t } = useI18n();

  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-4 lg:gap-10">
      {cards.map((card, index) => (
        <div className="relative" key={index}>
          {card.linkReference && card.enableLink ? (
            <ReferenceLink target={card.linkReference} className="cursor-pointer">
              <div className="relative">
                <div className="absolute bottom-0 left-0 right-0 top-0 bg-neutral-950-gradient"></div>
                <Image
                  media={card.image.media}
                  alt={t(card.image.title || '')}
                  sizes="(min-width: 640px) 25vw, 50vw"
                  className="transition-transform hover:scale-110"
                />
              </div>
              {card.text && (
                <div className="pointer-events-none absolute bottom-0 left-0 right-0 p-4 text-lg text-white lg:p-6 lg:text-2xl">
                  {card.text}
                </div>
              )}
            </ReferenceLink>
          ) : (
            <>
              <div className="relative">
                <div className="absolute bottom-0 left-0 right-0 top-0 bg-neutral-950-gradient"></div>
                <Image
                  media={card.image.media}
                  sizes="(min-width: 640px) 25vw, 50vw"
                  className="transition-transform hover:scale-110"
                />
              </div>
              {card.text && (
                <div className="pointer-events-none absolute bottom-0 left-0 right-0 hyphens-auto p-4 text-lg text-white lg:p-6 lg:text-2xl">
                  {card.text}
                </div>
              )}
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default CategoryCards;
